(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bubble-home-community"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bp-community]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const button = section.querySelector('[data-bp-toggle]');
    if (!button) return;
    button.addEventListener('click', () => {
      const paused = section.classList.toggle('is-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubble-home-hero"]) return;
  try {
    
  document.querySelectorAll('[data-bp-hero-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-bp-hero-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-bp-hero-go]'));
    let active = 0;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      carousel.classList.toggle('is-christmas-active', active === 1);
      carousel.classList.toggle('is-personalised-active', active === 2);
      slides.forEach((slide, i) => {
        const selected = i === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
        slide.inert = !selected;
      });
      dots.forEach((dot, i) => {
        const selected = i === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-pressed', String(selected));
      });
    };
    carousel.querySelector('[data-bp-hero-prev]')?.addEventListener('click', () => show(active - 1));
    carousel.querySelector('[data-bp-hero-next]')?.addEventListener('click', () => show(active + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.bpHeroGo))));
    show(0);
  });

  document.querySelectorAll('[data-bp-scroll-birthday]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const birthdayBoard = document.querySelector('[id^="BubbleBirthday-"]');
      if (!birthdayBoard) return;
      event.preventDefault();
      birthdayBoard.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  });


  document.querySelectorAll('[data-bp-home-nav]').forEach((nav) => {
    if (nav.dataset.bpNestedToggleReady === 'true') return;
    nav.dataset.bpNestedToggleReady = 'true';
    const closeItemAndDescendants = (item) => {
      item.classList.remove('is-open');
      item.querySelector(':scope > [data-bp-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
      item.querySelectorAll('.bp-home-header__item.is-open,.bp-home-header__nested-item.is-open').forEach((descendant) => {
        descendant.classList.remove('is-open');
        descendant.querySelector(':scope > [data-bp-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    };
    const closeOpenItems = () => {
      nav.querySelectorAll('.bp-home-header__item.is-open,.bp-home-header__nested-item.is-open').forEach((item) => {
        item.classList.remove('is-open');
        item.querySelector(':scope > [data-bp-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    };
    const closeSiblings = (item) => {
      Array.from(item.parentElement.children).forEach((sibling) => {
        if (sibling !== item && sibling.matches('.bp-home-header__item,.bp-home-header__nested-item')) {
          closeItemAndDescendants(sibling);
        }
      });
    };
    const hoverTimers = new WeakMap();
    const getHoverItem = (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const item = target?.closest('.bp-home-header__nested-item,.bp-home-header__item');
      return item && nav.contains(item) ? item : null;
    };
    const openHoveredItem = (event) => {
      if (event.pointerType === 'touch') return;
      const item = getHoverItem(event);
      if (!item || (event.relatedTarget && item.contains(event.relatedTarget))) return;
      const toggle = item.querySelector(':scope > [data-bp-submenu-toggle]');
      if (!toggle) return;
      const pending = hoverTimers.get(item);
      if (pending) window.clearTimeout(pending);
      closeSiblings(item);
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    };
    const closeHoveredItem = (event) => {
      if (event.pointerType === 'touch') return;
      const item = getHoverItem(event);
      if (!item || (event.relatedTarget && item.contains(event.relatedTarget))) return;
      const pending = hoverTimers.get(item);
      if (pending) window.clearTimeout(pending);
      const timer = window.setTimeout(() => {
        if (item.matches(':hover') || item.contains(document.activeElement)) return;
        closeItemAndDescendants(item);
      }, 220);
      hoverTimers.set(item, timer);
    };
    // Pointer events cover modern browsers; mouse events keep desktop hover reliable
    // where pointer media-query detection or synthesized pointer events are unavailable.
    nav.addEventListener('pointerover', openHoveredItem);
    nav.addEventListener('mouseover', openHoveredItem);
    nav.addEventListener('pointerout', closeHoveredItem);
    nav.addEventListener('mouseout', closeHoveredItem);
    nav.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-bp-submenu-toggle]');
      if (!toggle || !nav.contains(toggle)) return;
      event.preventDefault();
      event.stopPropagation();
      const item = toggle.closest('.bp-home-header__nested-item,.bp-home-header__item');
      if (!item) return;
      const shouldOpen = !item.classList.contains('is-open');
      if (shouldOpen) closeSiblings(item);
      else closeItemAndDescendants(item);
      item.classList.toggle('is-open', shouldOpen);
      toggle.setAttribute('aria-expanded', String(shouldOpen));
    });
    nav.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeOpenItems();
      nav.querySelector('[data-bp-submenu-toggle][aria-expanded="true"]')?.focus();
    });
    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target)) closeOpenItems();
    });
  });

  if (!document.documentElement.dataset.bpHomeHoverDelegationReady) {
    document.documentElement.dataset.bpHomeHoverDelegationReady = 'true';
    const bpHomeHoverSelector = '[data-bp-home-nav] .bp-home-header__item--dropdown, [data-bp-home-nav] .bp-home-header__nested-item--dropdown';
    const bpHomeHoverTimers = new WeakMap();
    const bpHomeCloseHoveredItem = (item) => {
      item.classList.remove('is-open');
      item.querySelector(':scope > [data-bp-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
      item.querySelectorAll('.bp-home-header__item.is-open,.bp-home-header__nested-item.is-open').forEach((child) => {
        child.classList.remove('is-open');
        child.querySelector(':scope > [data-bp-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    };
    document.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch') return;
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const item = target?.closest(bpHomeHoverSelector);
      if (!item || (event.relatedTarget && item.contains(event.relatedTarget))) return;
      const pending = bpHomeHoverTimers.get(item);
      if (pending) window.clearTimeout(pending);
      Array.from(item.parentElement.children).forEach((sibling) => {
        if (sibling !== item && sibling.matches('.bp-home-header__item,.bp-home-header__nested-item')) bpHomeCloseHoveredItem(sibling);
      });
      item.classList.add('is-open');
      item.querySelector(':scope > [data-bp-submenu-toggle]')?.setAttribute('aria-expanded', 'true');
    });
    document.addEventListener('pointerout', (event) => {
      if (event.pointerType === 'touch') return;
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const item = target?.closest(bpHomeHoverSelector);
      if (!item || (event.relatedTarget && item.contains(event.relatedTarget))) return;
      const pending = bpHomeHoverTimers.get(item);
      if (pending) window.clearTimeout(pending);
      bpHomeHoverTimers.set(item, window.setTimeout(() => {
        if (item.matches(':hover') || item.contains(document.activeElement)) return;
        bpHomeCloseHoveredItem(item);
      }, 180));
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
